import type { AxiosInstance, AxiosResponse } from 'axios';
import type { NahledyUdajuResponse } from '@gov-nx/module/service';

export const driversRegistryResults = async (
	axiosInstance: AxiosInstance,
	source: string
): Promise<AxiosResponse<NahledyUdajuResponse>> =>
	axiosInstance.get<NahledyUdajuResponse>(
		`/api/v1/nahledyudaju?zdrojUdaju=${source}`
	);
